import PropTypes from 'prop-types';

import {v4 as uuidv4} from 'uuid';

import * as cliparts from 'assets/cliparts';
import {Group, loadSVGFromString, util} from 'fabric';

import {isCustom, limitReached, setLastObjectActive} from '../canvas-helper';

const SIZE = 40;

const Clipart = ({canvas, color, clipart}) => {
    canvas.on({
        'mouse:down': (o) => {
            if (limitReached(canvas)) {
                return;
            }

            if (canvas.getActiveObject()) {
                if (isCustom(canvas.getActiveObject())) {
                    return;
                }

                canvas.discardActiveObject();
            }

            loadSVGFromString(cliparts[clipart]).then(({objects}) => {
                let pointer = canvas.getScenePoint(o.e);
                let img = util.groupSVGElements(objects);
                img.scaleToWidth(SIZE);
                img.originX = 'center';
                img.originY = 'center';

                if (img.getObjects) {
                    const svgObjects = img.getObjects();
                    svgObjects[0].set('fill', color.value1);
                    svgObjects[1].set('fill', color.value2);
                    if (clipart === 'futbol') {
                        // football is always black and white
                        svgObjects[0].set('fill', '#ffffff');
                        svgObjects[1].set('fill', '#000000');
                    }
                } else {
                    img.set('fill', color.value1);
                }

                const group = new Group([img], {
                    custom: {
                        type: 'clipart',
                        clipart,
                        id: uuidv4()
                    },
                    left: pointer.x,
                    top: pointer.y,
                    hasBorders: false,
                    hasControls: false,
                });

                canvas.add(group);
                setLastObjectActive(canvas);
            });
        },
    });
};

Clipart.propTypes = {
    canvas: PropTypes.object.isRequired
};

export default Clipart;